export enum LoginStageStatus {
  INITIAL,
  PROCESSING,
  SUCCESS,
  ERROR
}

export enum LoginStageStep {
  STEP_1 = 1,
  STEP_2 = 2,
  STEP_3 = 3
}

export type LoginStageProp = {
  step: number | null
  status: LoginStageStatus | null
  error?: string | null
}

export type LoginStage = {
  step: number
  status: LoginStageStatus | null
  message: string
  icon: JSX.Element
  error?: string | null
}
